import React from 'react'
import { Card, FlexView, Spinner } from 'components/common'
import { ResponsiveContainer, Tooltip, ComposedChart, XAxis, YAxis, Legend, Bar, Line } from 'recharts'
import { useTranslation } from 'react-i18next'
import { useContext } from 'react'
import { StockContext } from 'stores/StockStore'

const StockHistoryChartCard = props => {
  const { t } = useTranslation()
  const { isLoading, tableData } = useContext(StockContext)

  return <Card style={{ overflow: 'hidden' }} {...props}>
    <FlexView fontSize="big" fontWeight="bold" margin="0px 0px 16px">{t('service.lineChartMonthByPieces')}</FlexView>
    {isLoading ?
      <FlexView justifyContent="center" alignItems="center" width="100%" height="100%">
        <Spinner />
      </FlexView>
      :
      <ResponsiveContainer width="99%">
        <ComposedChart data={tableData} margin={{ top: 0 }}>
          <XAxis dataKey="month" tick={{fontSize: 12}} />
          <YAxis yAxisId="left" orientation="left" tick={{fontSize: 12}} />
          <YAxis yAxisId="right" orientation="right" tick={{fontSize: 12}} />
          <Tooltip />
          <Legend />
          <Bar yAxisId="left" dataKey="received" name={t('service.tableReceived')} barSize={30} fill="#00a0e3" />
          <Bar yAxisId="left" dataKey="returned" name={t('service.tableReturned')} barSize={30} fill="#2d2183" />
          <Line yAxisId="right" type="monotone" name={t('service.tablePieces')} dataKey="pieces" stroke="#8c83b6" activeDot={{ r: 2 }} strokeWidth={2}  />
        </ComposedChart>
      </ResponsiveContainer>
    }
  </Card>
}

export default StockHistoryChartCard